export default function EuRailRailcardsModalService(
    railsService
) {
    'ngInject';

    Object.assign(this, {
        getRailcards,
    });

    function getRailcards() {
        return railsService.getStaticData()
            .then((data) => _.groupBy(data.TrainlineCardTypes, (card) => card.Vendor));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/eurail-railcards-modal/eurail-railcards-modal-service.js